import React from 'react';
import { TopBanner } from './top-banner/top-banner.component';
import { SessionPrompts } from './session-prompts.component';
export const AppNotices = () => {
  return <>
      <TopBanner />
      <SessionPrompts />
    </>;
};